import React from "react";


const Resume = () =>{
    return(
        <section className="resume" id="resume">
            <div className="title">
                <h3>Resume</h3>
            </div>
            <div className="contet-resume">
                <div className="colu right">
                    <h3>Sumary</h3>
                    <article>
                        <p>Desarrollador Java con experiencia en el desarrollo de aplicaciones web usando Java, Spring Boot, Hibernate y Thymeleaf.
                            Habilidades en FullStack con Laravel, Izfe y Django, y en la gestión de bases de datos con JPA, Hibernate, Eloquent, SQL y Oracle. 
                            Formación técnica en Desarrollo de Aplicaciones Web y especialización en Java. Experiencia en colaboración con equipos de diseño y desarrollo, con un enfoque en la mejora continua y la adopción de prácticas ágiles. Busco contribuir a proyectos innovadores y desafiantes.</p>
                    </article>
                    <h3>Education</h3>
                    <article>
                        <h4>Programa Especialización Tecnologia Java</h4>
                        <p>IES Xabier Zubiri Manteo | 2023-2024</p>
                        <p>Donostia - San Sebastian</p>
                    </article>
                    <article>
                        <h4>TÉCNICO SUPERIOR EN DESARROLLO DE APLICACIONES WEB</h4>
                        <p>IES Xabier Zubiri Manteo | 2021-2023</p>
                        <p>Donostia - San Sebastian</p>
                    </article>
                    <article>
                        <h4>Certificado De Tipo 2 - Confeccion y publicacion Web</h4>
                        <p>Ceinpro | 2021-2022</p>
                        <p>Donostia - San Sebastian</p>
                    </article>
                    <article>
                        <h4>Grado Ingeniería Informatica 2 años(sin terminar)</h4>
                        <p>Universidad Politecnica Madrid | 2013-2016</p>
                        <p>Madrid</p>
                    </article>
                    <h3>Other Courses</h3>
                    <article>
                        <h4>Machine learning aplicado usando Python (130h)</h4>
                        <p>FUNDACION JASON | 2024</p>
                    </article>
                    <article>
                        <h4>Angula de cero a experto (50h)</h4>
                        <p>DEV/TALLES | 2024</p>
                    </article>
                    <article>
                        <h4>React: De cero a experto ( Hooks y MERN ) (60H)</h4>
                        <p>DEV/TALLES | 2024</p>
                    </article>
                    <article>
                        <h4>UNITY3D ( 40H )</h4>
                        <p>CEINPRO | 2022</p>
                    </article>
                    <article>
                        <h4>Ciberseguridad ( UC0488_3 ) ( 60H )</h4>
                        <p>CEBANC | 2022</p>
                    </article>
                    <article>
                        <h4>Desarrollo de aplicaciones en NODE.JS Y EXPRESS (30H)</h4>
                        <p>CEINPRO | 2022</p>
                    </article>
                    <article>
                        <h4>JavaScript Avanzado ( 30H )</h4>
                        <p>CEINPRO | 2022</p>
                    </article>
                </div>
                <div className="colu">
                    <h3>Professional Experience</h3>
                    <article>
                        <h4>Desarrollador JAVA</h4>
                        <p className="estiquetaTitle">IBERMATICA (Ayesa)</p>
                        <p className="dateTitle">Marzo 2023 - Junio 2024</p>
                        <ul>
                            <li><i class="fa-solid fa-caret-right"></i> Desarrollo y mantenimiento de aplicaciones web utilizando
                            Java y Jakarta.</li>
                            <li><i class="fa-solid fa-caret-right"></i> Implementación y configuración del ecosistema Spring,
                            incluyendo Spring Boot e Hibernate.</li>
                            <li><i class="fa-solid fa-caret-right"></i> Creación de interfaces de usuario dinámicas con Thymeleaf,
                            JSP y JSTL.</li>
                            <li><i class="fa-solid fa-caret-right"></i> Desarrollo de aplicaciones utilizando el Framework IZFE
                            basado en Java Spring.</li>
                            <li><i class="fa-solid fa-caret-right"></i> Gestión de bases de datos con JPA y Hibernate.</li>
                            <li><i class="fa-solid fa-caret-right"></i> Finalización de un proyecto de especialización, desarrollando
                            una aplicación con Spring Boot, JPA, Hibernate y Thymeleaf</li>
                        </ul>
                    </article>
                    <article>
                        <h4>Desarrollador Front-End</h4>
                        <p className="estiquetaTitle">Practicas en Dastatzen Group.</p>
                        <p className="dateTitle">Marzo 2022 - Julio 2022</p>
                        <ul>
                            <li><i class="fa-solid fa-caret-right"></i> Mantenimiento y mejora continua de la aplicación matriz.</li>
                            <li><i class="fa-solid fa-caret-right"></i> Implementación y mantenimiento de aplicaciones utilizando
                            el framework Laravel.</li>
                            <li><i class="fa-solid fa-caret-right"></i> Actualización y optimización del sitio web de Iruki basado en
                            WordPress.</li>
                            <li><i class="fa-solid fa-caret-right"></i> Colaboración efectiva con diseñadores y marketing
                            para implementar cambios y nuevas características.</li>
                        </ul>
                    </article>
                    <article>
                        <h4>Adjunto Gerente /Jefe de Turno</h4>
                        <p className="estiquetaTitle">Grupo CHAMPIONS.</p>
                        <p className="dateTitle">Octubre 2014 - Marzo 2021</p>
                        <ul>
                            <li><i class="fa-solid fa-caret-right"></i> Coordinación de horarios y supervisión de equipos de trabajo.</li>
                            <li><i class="fa-solid fa-caret-right"></i> Gestión de inventarios, stock y control de pedidos.</li>
                            <li><i class="fa-solid fa-caret-right"></i> Capacitación y formación de nuevas incorporaciones.</li>
                            <li><i class="fa-solid fa-caret-right"></i> Manejo de operaciones de caja y contabilidad diaria.</li>
                            <li><i class="fa-solid fa-caret-right"></i> Realización de reuniones informativas antes de cada jornada.</li>
                            <li><i class="fa-solid fa-caret-right"></i> Planificación y ejecución de estrategias comerciales.</li>
                        </ul>
                    </article>
                </div>
            </div>
        </section>
    );
}
export default Resume;